import React, { useEffect, useState } from "react"
import { Col , OverlayTrigger , Tooltip } from "react-bootstrap";

import { RadioMarking } from "./"
import { Common, MarkingColors } from "../../../helper";

import "../../../assets/stlyes/marking.scss";

const MarkRow = (props) => {
  const { firstName, lastName, description, index, _markings, updateMarks, cards, year, finalUpdatedData, _description, pupil, pupilMarkss, redFill } = props;
  const [bgColor, setBgColor] = useState(MarkingColors.White);

  const setBG = () => {
    switch (_markings[index].markings[0]) {
    case `${year}B`: setBgColor(MarkingColors.Below); break;
    case `${year}W`: setBgColor(MarkingColors.Emerging); break;
    case `${year}E`: setBgColor(MarkingColors.Expected); break;
    case `${year}G`: setBgColor(MarkingColors.GreaterDepth); break;
    case "0": setBgColor(MarkingColors.Absent); break;
    default:  break;
    }
  }

  useEffect(() => {
    setBG()
  }, [])
  
  return (
    <tr className="tr-border-bottom">
      <td className="mark-editor-pupil-list" style={{ minWidth: "244px", background: "#FAFAFA", boxShadow: "3px 0px 5px 0px rgba(0, 0, 0, 0.07)" }}>
        <div className="d-flex" style={{ paddingLeft: "31px" }}>
          {<div className="previous-mark-indicator" style={{ padding: "15px 0px" }}>
            {_markings[index].markings[0] !== "0" ? <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{_markings[index].comment}</Tooltip>}>
              <span className="d-inline-block">
                <div style={{ background: bgColor, width: "45px", height: "24px", borderRadius: "25px", paddingLeft:"7px" }}><span style={{ color: "white" }}><span style={{ width: "11px", height: "12px" }}>&nbsp;{_markings[index].markings.length > 1 ? _markings[index].markings[1] : _markings[index].markings[0]}</span></span></div>
              </span>
            </OverlayTrigger> : <div style={{ width: "45px" }}></div>}&nbsp;
          </div>}
          <div className="pupil" style={{ display: "flex", flexDirection: "column" }}>
            <Col xs={12} style={{ padding: "7px 10px 0px 10px" }}>
              <span className="pupil-name">{`${firstName} ${lastName} `}</span>
            </Col>
            <Col xs={12} style={{ display: "flex", padding: "0px 10px 5px 10px" }}>
              {pupil[index].otherNeeds.pupilPremium ? <div className="pp-indicator" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "25px", gap: "3px" }}><span className="pp-dot" style={{ display: "flex", width: "3px", height: "3px", background: "#6D47FF" }}> </span><span className="pp-text" style={{ color: "#084059", fontSize: "8px", fontWeight: "400" }}>{Common.PP}</span></div> : ""}
              {pupil[index].otherNeeds.eal ? <div className="eal-indicator" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "25px", gap: "3px" }}><span className="eal-dot" style={{ display: "flex", width: "3px", height: "3px", background: "#F4C900" }}> </span><span className="eal-text" style={{ color: "#084059", fontSize: "8px", fontWeight: "400" }}>{Common.Eal}</span></div> : ""}
              {pupil[index].otherNeeds.ehcp ? <div className="sc-indicator" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "25px", gap: "3px" }}><span className="sc-dot" style={{ display: "flex", width: "3px", height: "3px", background: "#6D47FF" }}> </span><span className="sc-text" style={{ color: "#084059", fontSize: "8px", fontWeight: "400" }}>{Common.Ehcp}</span></div> : ""}
              {pupil[index].otherNeeds.senStatus ? <div className="sc-indicator" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "25px", gap: "3px" }}><span className="sc-dot" style={{ display: "flex", width: "3px", height: "3px", background: "#F50057" }}> </span><span className="sc-text" style={{ color: "#084059", fontSize: "8px", fontWeight: "400" }}>{Common.SEND}</span></div> : ""}
            </Col>
          </div>
        </div>
      </td>
      <RadioMarking description={description} _markings={_markings} index={index} updateMarks={updateMarks} cards={cards} year={year} finalUpdatedData={finalUpdatedData} _description={_description} pupilMarkss={pupilMarkss} redFill={redFill} />
    </tr>
  )
}

export { MarkRow }